module.exports = __webpack_public_path__ + "static/8-1-0a8da8b1e177c1e41913c810733d74e9.jpg";